import React, { forwardRef } from "react";
import { TableProps } from "./Table.types";
import {
  Table as StyledTable,
  TableFlex as StyledTableFlex
} from "./Table.styles";

/**
 * Main Table component
 */
export const Table = forwardRef<HTMLDivElement, TableProps>(
  ({ children, className }, ref) => (
    <StyledTable ref={ref} className={className}>
      {children}
    </StyledTable>
  )
);

Table.displayName = "Table";

/**
 * Flex variant of the Table component
 */
export const TableFlex = forwardRef<HTMLDivElement, TableProps>(
  ({ children, className }, ref) => (
    <StyledTableFlex ref={ref} className={className}>
      {children}
    </StyledTableFlex>
  )
);

TableFlex.displayName = "TableFlex";
